import PropTypes from 'prop-types';
import getParameterNames from 'get-parameter-names';

import { findIndex } from 'lodash';

const withCheckTypes = (fn, checkTypes = () => {}) => {
  fn.checkTypes = checkTypes;
  return fn;
};

const typeCheckerForArgs = (functionName, argumentNames, argumentPropTypes) => (...args) => {
  argumentPropTypes.forEach((propType, i) => {
    const arg = args[i];
    const argKey = argumentNames[i] || `arguments[${i}]`;
    PropTypes.checkPropTypes({[argKey]: propType}, {[argKey]: arg}, `argument`, functionName);
  });
  if (argumentPropTypes.length < args.length) {
    console.error(`${functionName}: call with extra arguments: ` +
      `expected ${argumentPropTypes.length}, got ${args.length}`);
  }
};


// argTypes takes a name (function or type name) and an associated list of argument propTypes and returns an
// argument type checker function that can wrap a function that needs to be type-checked on entry. Type checks
// can also be explicitly requested using the [wrapper].checkTypes(...arguments);
//
//     const typeChecker = argTypes('concat-two-strings',
//                                  PropTypes.string.isRequired, PropTypes.string.isRequired);
//     typeChecker.checkTypes('a', 'b')    // OK, two string parameters
//     typeChecker.checkTypes('a', 2)      // Not OK
//
//     const typeCheckingFn = typeChecker((a, b) => a + b);  // typeCheckingFn runs type checks before calling target
//     typeCheckingFn('a', 'b')                              // type checks ok, => 'ab'
//     typeCheckingFn('a', 3)                                // type check fails with warning, still returns => 'a3'
//
export const argTypes = (name, ...argumentPropTypes) => {
  if (process.env.NODE_ENV === 'production') {
    return withCheckTypes(fn => fn); // type checking disabled in production
  }

  if (typeof name !== 'string') {
    throw new Error("argTypes must start with a name");
  }

  if (!argumentPropTypes.length) {
    throw new Error("argTypes must have non-empty list of prop types to check");
  }

  if (findIndex(argumentPropTypes, propType => !propType) !== -1) {
    throw new Error("argTypes must not contain invalid prop types");
  }

  return withCheckTypes(fn => {
    const checkTypes = typeCheckerForArgs(name, getParameterNames(fn), argumentPropTypes);

    const typeCheckingFn = (...args) => {
      checkTypes(...args);
      return fn(...args);
    };
    typeCheckingFn.unchecked = fn;
    return typeCheckingFn;
  }, typeCheckerForArgs(name, [], argumentPropTypes));
};

export default argTypes;
